import { defineComponent } from "vue";
export default defineComponent({
    name: "BindProjectTips",
    setup: function setup() {
        return {
            content: "\u8BE5\u9879\u76EE\u5DF2\u5173\u8054\u9700\u6C42\uFF0C\u82E5\u9700\u7F16\u8F91\uFF0C\u7F16\u8F91\u5B8C\u6210\u540E\u8BF7\u64CD\u4F5C\u201C\u66F4\u65B0\u57FA\u7840\u5305\u201D"
        };
    }
});
